export class LimitedStack<T> {
  private buffer: T[];
  private head: number; // Points to the next insertion point
  private size: number; // Current size of the stack
  private maxLength: number;

  constructor(maxLength: number);
  constructor(stackToClone: LimitedStack<T>);
  constructor(arg: any) {
    if (typeof arg === 'number') {
      // Original constructor logic
      this.maxLength = arg;
      this.buffer = new Array(this.maxLength);
      this.head = 0;
      this.size = 0;
    } else if (arg instanceof LimitedStack) {
      // Cloning constructor logic
      const stackToClone: LimitedStack<T> = arg;
      this.maxLength = stackToClone.maxLength;
      this.buffer = [...stackToClone.buffer];
      this.head = stackToClone.head;
      this.size = stackToClone.size;
    } else {
      throw new Error('Invalid argument type');
    }
  }

  push(item: T): void {
    this.buffer[this.head] = item;
    this.head = (this.head + 1) % this.maxLength;
    if (this.size < this.maxLength) {
      this.size++;
    }
  }

  pop(): T | undefined {
    if (this.size === 0) {
      return undefined;
    }

    this.head = (this.head - 1 + this.maxLength) % this.maxLength;
    const item = this.buffer[this.head];
    this.size--;
    return item;
  }

  getSize(): number {
    return this.size;
  }

  getMaxLength(): number {
    return this.maxLength;
  }
}
